import { createSlice } from '@reduxjs/toolkit';
import AuthService from './AuthService'

const initialState = {
    session: undefined
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser(state, action) {
            state.session = action.payload;
            if (action.payload != null) {
                AuthService.SetCurrentUser(JSON.stringify(action.payload));
            }
        },
        deleteUser(state, action) {
            state.session = action.payload
        },
    }
});

export const {
    setUser,
    deleteUser
} = userSlice.actions;

export default userSlice.reducer;